import { render, staticRenderFns } from "./DividerElement.vue?vue&type=template&id=61196d9a&scoped=true&"
import script from "./DividerElement.vue?vue&type=script&lang=js&"
export * from "./DividerElement.vue?vue&type=script&lang=js&"
import style0 from "./DividerElement.vue?vue&type=style&index=0&id=61196d9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61196d9a",
  null
  
)

export default component.exports